import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { loadNeonGlobalStylesAndFonts } from '@ps-refarch-ux/neon';
import { AppAuthProvider } from './auth/auth0-provider';
import { App } from './App';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

// Neon design system: mark the React root and inject neon's global styles + fonts.
rootElement.setAttribute('neon-react-root', '');
loadNeonGlobalStylesAndFonts();

createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppAuthProvider>
        <App />
      </AppAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
